module.exports = __webpack_public_path__ + "img/carat.ea30161.jpg";